const GET_COMMENTS_REJECTED_BOOKING = 'booking/get-comments-rejected-booking';
module.exports = {
    getCommentRejectedBooking: function getCommentRejectedBooking(id){
        return window.axios.get(GET_COMMENTS_REJECTED_BOOKING + '/' + id);
    },
};
